import React from "react";

import {
  Box,
  Button,
  CircularProgress,
  Paper,
  TextField,
  Typography
} from "@material-ui/core";

import api
  from "../../services/api";

import {
  Document,
  Page,
  pdfjs
} from "react-pdf";


// KORAX SIGN PDF VIEWER V0.5B
pdfjs.GlobalWorkerOptions.workerSrc =
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


const onlyDigits =
  value =>
    String(
      value ||
      ""
    )
      .replace(
        /\D/g,
        ""
      )
      .slice(
        0,
        6
      );


const KoraxSignPublic = ({
  match
}) => {

  const token =
    React.useMemo(
      () => {

        const hashToken =
          String(
            window.location.hash ||
            ""
          )
            .replace(
              /^#/,
              ""
            )
            .trim();


        if (
          /^[a-fA-F0-9]{64}$/
            .test(hashToken)
        ) {

          return hashToken
            .toLowerCase();
        }


        // Link curto: 256 bits em Base64URL.
        // A API continua recebendo o token hexadecimal.
        if (/^[A-Za-z0-9_-]{43}$/.test(hashToken)) {
          try {
            const binary = window.atob(
              hashToken
                .replace(/-/g, "+")
                .replace(/_/g, "/") + "="
            );

            if (binary.length === 32) {
              return Array.from(binary)
                .map(char =>
                  char.charCodeAt(0)
                    .toString(16)
                    .padStart(2, "0")
                )
                .join("");
            }
          } catch {
            // Fragmento invalido: mantém fallback legado.
          }
        }

        const legacy =
          String(
            match
              ?.params
              ?.token ||
            ""
          )
            .trim();


        if (
          /^[a-fA-F0-9]{64}$/
            .test(legacy)
        ) {

          window.history
            .replaceState(
              {},
              "",
              `/sign#${legacy}`
            );


          return legacy
            .toLowerCase();
        }


        return "";
      },
      [
        match
      ]
    );


  const sessionKey =
    token
      ? `korax-sign-verification-${token.slice(0, 16)}`
      : "";


  const [
    loading,
    setLoading
  ] =
    React.useState(true);

  const [
    sending,
    setSending
  ] =
    React.useState(false);

  const [
    verifying,
    setVerifying
  ] =
    React.useState(false);

  const [
    error,
    setError
  ] =
    React.useState("");

  const [
    success,
    setSuccess
  ] =
    React.useState("");

  const [
    session,
    setSession
  ] =
    React.useState(null);

  const [
    code,
    setCode
  ] =
    React.useState("");

  const [
    codeSent,
    setCodeSent
  ] =
    React.useState(false);

  const [
    cooldown,
    setCooldown
  ] =
    React.useState(0);

  const [
    verified,
    setVerified
  ] =
    React.useState(false);

  const [
    verificationToken,
    setVerificationToken
  ] =
    React.useState(
      () => {

        if (
          !sessionKey
        ) {

          return "";
        }


        return (
          window
            .sessionStorage
            .getItem(
              sessionKey
            ) ||
          ""
        );
      }
    );


  const [
    pdfUrl,
    setPdfUrl
  ] =
    React.useState("");

  const [
    pdfLoading,
    setPdfLoading
  ] =
    React.useState(false);

  const [
    pdfError,
    setPdfError
  ] =
    React.useState("");

  const [
    pdfPages,
    setPdfPages
  ] =
    React.useState(0);

  const [
    pdfPage,
    setPdfPage
  ] =
    React.useState(1);

  const [
    pdfWidth,
    setPdfWidth
  ] =
    React.useState(
      () =>
        Math.max(
          260,
          Math.min(
            560,
            window.innerWidth -
              80
          )
        )
    );


  // KORAX SIGN SIGNATURE UI V0.6A

  const [
    consentAccepted,
    setConsentAccepted
  ] =
    React.useState(false);

  const [
    signatureMode,
    setSignatureMode
  ] =
    React.useState("DRAWN");

  const [
    signatureText,
    setSignatureText
  ] =
    React.useState("");

  const [
    signatureDrawn,
    setSignatureDrawn
  ] =
    React.useState(false);

  const [
    signing,
    setSigning
  ] =
    React.useState(false);

  const [
    signError,
    setSignError
  ] =
    React.useState("");

  const [
    signed,
    setSigned
  ] =
    React.useState(false);

  // KORAX SIGN FINAL UI V0.6B

  const [
    finalizing,
    setFinalizing
  ] =
    React.useState(false);

  const [
    finalReady,
    setFinalReady
  ] =
    React.useState(false);

  const [
    finalError,
    setFinalError
  ] =
    React.useState("");


  const canvasRef =
    React.useRef(null);

  const drawingRef =
    React.useRef(false);


  const loadSession =
    React.useCallback(
      async (
        currentVerificationToken =
          verificationToken
      ) => {

        if (!token) {

          setError(
            "Link de assinatura inválido."
          );

          setLoading(
            false
          );

          return;
        }


        try {

          const response =
            await api.post(
              "/korax-sign/public/session",
              {
                token,
                verificationToken:
                  currentVerificationToken ||
                  undefined
              }
            );


          const nextSession =
            response
              .data
              .session;


          setSession(
            nextSession
          );

            // Sincroniza o estado com o servidor apos validar o email.
            if (nextSession?.verified) {
              const serverSigned =
                Boolean(nextSession.signed);

              const serverFinalReady =
                Boolean(nextSession.finalPdfReady);

              setSigned(serverSigned);
              setFinalReady(serverFinalReady);

              const signedKey =
                `korax_sign_signed_${token.slice(0, 16)}`;

              const finalKey =
                `korax_sign_final_${token.slice(0, 16)}`;

              if (serverSigned) {
                window.sessionStorage.setItem(signedKey, "1");
              } else {
                window.sessionStorage.removeItem(signedKey);
              }

              if (serverFinalReady) {
                window.sessionStorage.setItem(finalKey, "1");
              } else {
                window.sessionStorage.removeItem(finalKey);
              }
            }



          setVerified(
            Boolean(
              nextSession
                ?.verified
            )
          );


          setCooldown(
            Number(
              nextSession
                ?.otpCooldownSeconds ||
              0
            )
          );


          if (
            currentVerificationToken &&
            !nextSession
              ?.verified
          ) {

            window
              .sessionStorage
              .removeItem(
                sessionKey
              );

            setVerificationToken(
              ""
            );
          }

        } catch (err) {

          setError(
            err?.response
              ?.data
              ?.message ||
            "Não foi possível abrir este link de assinatura."
          );

        } finally {

          setLoading(
            false
          );
        }
      },
      [
        token,
        verificationToken,
        sessionKey
      ]
    );


  React.useEffect(
    () => {

      loadSession();

    },
    []
  );


  React.useEffect(
    () => {

      if (
        cooldown <= 0
      ) {

        return undefined;
      }


      const timer =
        window.setInterval(
          () => {

            setCooldown(
              current =>
                Math.max(
                  0,
                  current - 1
                )
            );
          },
          1000
        );


      return () => {

        window.clearInterval(
          timer
        );
      };
    },
    [
      cooldown
    ]
  );


  const requestCode =
    async () => {

      setSending(
        true
      );

      setError("");

      setSuccess("");


      try {

        const response =
          await api.post(
            "/korax-sign/public/email-otp/request",
            {
              token
            }
          );


        setCodeSent(
          true
        );

        setCooldown(
          Number(
            response
              .data
              .resendAfterSeconds ||
            60
          )
        );

        setSuccess(
          `Código enviado para ${response.data.emailMasked}.`
        );

      } catch (err) {

        const retryAfter =
          Number(
            err?.response
              ?.data
              ?.retryAfterSeconds ||
            0
          );


        if (
          retryAfter > 0
        ) {

          setCooldown(
            retryAfter
          );
        }


        setError(
          err?.response
            ?.data
            ?.message ||
          "Não foi possível enviar o código."
        );

      } finally {

        setSending(
          false
        );
      }
    };


  const verifyCode =
    async () => {

      if (
        code.length !==
        6
      ) {

        setError(
          "Digite o código de 6 dígitos."
        );

        return;
      }


      setVerifying(
        true
      );

      setError("");

      setSuccess("");


      try {

        const response =
          await api.post(
            "/korax-sign/public/email-otp/verify",
            {
              token,
              code
            }
          );


        const rawVerificationToken =
          response
            .data
            .verificationToken;


        window
          .sessionStorage
          .setItem(
            sessionKey,
            rawVerificationToken
          );


        setVerificationToken(
          rawVerificationToken
        );

        setVerified(
          true
        );

        setCode("");

        setSuccess(
          "E-mail verificado com sucesso."
        );


        await loadSession(
          rawVerificationToken
        );

      } catch (err) {

        const remaining =
          err?.response
            ?.data
            ?.remainingAttempts;


        const baseMessage =
          err?.response
            ?.data
            ?.message ||
          "Não foi possível validar o código.";


        setError(
          typeof remaining ===
            "number"
            ? `${baseMessage} Tentativas restantes: ${remaining}.`
            : baseMessage
        );

      } finally {

        setVerifying(
          false
        );
      }
    };


  React.useEffect(
    () => {

      const updatePdfWidth =
        () => {

          setPdfWidth(
            Math.max(
              260,
              Math.min(
                560,
                window.innerWidth -
                  80
              )
            )
          );
        };


      updatePdfWidth();


      window.addEventListener(
        "resize",
        updatePdfWidth
      );


      return () => {

        window.removeEventListener(
          "resize",
          updatePdfWidth
        );
      };
    },
    []
  );


  React.useEffect(
    () => {

      if (
        !verified ||
        !verificationToken ||
        !token
      ) {

        return undefined;
      }


      let mounted =
        true;

      let objectUrl =
        "";


      const loadProtectedPdf =
        async () => {

          setPdfLoading(
            true
          );

          setPdfError("");


          try {

            const response =
              await api.post(
                "/korax-sign/public/pdf",
                {
                  token,
                  verificationToken
                },
                {
                  responseType:
                    "blob"
                }
              );


            if (!mounted) {
              return;
            }


            const blob =
              response.data
                instanceof Blob
                ? response.data
                : new Blob(
                    [
                      response.data
                    ],
                    {
                      type:
                        "application/pdf"
                    }
                  );


            objectUrl =
              window.URL
                .createObjectURL(
                  blob
                );


            setPdfUrl(
              current => {

                if (current) {

                  window.URL
                    .revokeObjectURL(
                      current
                    );
                }


                return objectUrl;
              }
            );


            setPdfPage(
              1
            );

          } catch (err) {

            if (!mounted) {
              return;
            }


            const status =
              Number(
                err?.response
                  ?.status ||
                0
              );


            if (
              status === 401 ||
              status === 403
            ) {

              if (sessionKey) {

                window
                  .sessionStorage
                  .removeItem(
                    sessionKey
                  );
              }


              setVerificationToken(
                ""
              );

              setVerified(
                false
              );


              setError(
                "Sua sessão segura expirou. Confirme o e-mail novamente."
              );

            } else {

              setPdfError(
                "Não foi possível carregar o documento."
              );
            }

          } finally {

            if (mounted) {

              setPdfLoading(
                false
              );
            }
          }
        };


      loadProtectedPdf();


      return () => {

        mounted =
          false;


        if (objectUrl) {

          window.URL
            .revokeObjectURL(
              objectUrl
            );
        }
      };
    },
    [
      verified,
      verificationToken,
      token,
      sessionKey
    ]
  );


  React.useEffect(
    () => {

      if (
        !verified ||
        !signed ||
        !verificationToken ||
        finalReady ||
        finalizing
      ) {

        return undefined;
      }


      let cancelled =
        false;


      const finalize =
        async () => {

          setFinalizing(
            true
          );

          setFinalError("");


          try {

            const response =
              await api.post(
                "/korax-sign/public/finalize",
                {
                  token,
                  verificationToken
                }
              );


            if (
              !cancelled &&
              response
                .data
                ?.finalPdfReady
            ) {

              setFinalReady(
                true
              );


              window
                .sessionStorage
                .setItem(
                  `korax_sign_final_${token.slice(0, 16)}`,
                  "1"
                );
            }

          } catch (err) {

            if (cancelled) {
              return;
            }


            const status =
              Number(
                err?.response
                  ?.status ||
                0
              );


            if (
              status === 401 ||
              status === 403
            ) {

              if (sessionKey) {

                window
                  .sessionStorage
                  .removeItem(
                    sessionKey
                  );
              }


              setVerificationToken(
                ""
              );

              setVerified(
                false
              );


              setFinalError(
                "Sua sessão segura expirou. Confirme o e-mail novamente."
              );

            } else {

              setFinalError(
                err?.response
                  ?.data
                  ?.message ||
                "Não foi possível preparar o documento final."
              );
            }

          } finally {

            if (!cancelled) {

              setFinalizing(
                false
              );
            }
          }
        };


      finalize();


      return () => {

        cancelled =
          true;
      };
    },
    [
      verified,
      signed,
      verificationToken,
      finalReady,
      token,
      sessionKey
    ]
  );


  const downloadFinalPdf =
    async () => {

      setFinalError("");


      try {

        const response =
          await api.post(
            "/korax-sign/public/final-pdf",
            {
              token,
              verificationToken
            },
            {
              responseType:
                "blob"
            }
          );


        const blobUrl =
          window.URL
            .createObjectURL(
              response.data
            );


        const link =
          document
            .createElement(
              "a"
            );


        link.href =
          blobUrl;

        link.download =
          "documento-assinado-korax.pdf";


        document
          .body
          .appendChild(
            link
          );


        link.click();

        link.remove();


        window.setTimeout(
          () => {

            window.URL
              .revokeObjectURL(
                blobUrl
              );
          },
          1000
        );

      } catch (err) {

        const status =
          Number(
            err?.response
              ?.status ||
            0
          );


        if (
          status === 401 ||
          status === 403
        ) {

          if (sessionKey) {

            window
              .sessionStorage
              .removeItem(
                sessionKey
              );
          }


          setVerificationToken(
            ""
          );

          setVerified(
            false
          );


          setFinalError(
            "Sua sessão segura expirou. Confirme o e-mail novamente."
          );

        } else {

          setFinalError(
            "Não foi possível baixar o documento assinado."
          );
        }
      }
    };


  const getCanvasPoint =
    event => {

      const canvas =
        canvasRef.current;


      if (!canvas) {

        return {
          x: 0,
          y: 0
        };
      }


      const rect =
        canvas
          .getBoundingClientRect();


      return {
        x:
          (
            event.clientX -
            rect.left
          ) *
          (
            canvas.width /
            rect.width
          ),

        y:
          (
            event.clientY -
            rect.top
          ) *
          (
            canvas.height /
            rect.height
          )
      };
    };


  const startDrawing =
    event => {

      if (
        signatureMode !==
        "DRAWN" ||
        signed
      ) {

        return;
      }


      const canvas =
        canvasRef.current;


      if (!canvas) {
        return;
      }


      event.preventDefault();


      try {

        canvas
          .setPointerCapture(
            event.pointerId
          );

      } catch {
        // navegador sem pointer capture
      }


      const context =
        canvas
          .getContext(
            "2d"
          );


      const point =
        getCanvasPoint(
          event
        );


      context.strokeStyle =
        "#101828";

      context.lineWidth =
        4;

      context.lineCap =
        "round";

      context.lineJoin =
        "round";

      context.beginPath();

      context.moveTo(
        point.x,
        point.y
      );


      drawingRef.current =
        true;
    };


  const drawSignature =
    event => {

      if (
        !drawingRef.current ||
        signatureMode !==
          "DRAWN"
      ) {

        return;
      }


      event.preventDefault();


      const canvas =
        canvasRef.current;


      if (!canvas) {
        return;
      }


      const context =
        canvas
          .getContext(
            "2d"
          );


      const point =
        getCanvasPoint(
          event
        );


      context.lineTo(
        point.x,
        point.y
      );

      context.stroke();

      setSignatureDrawn(
        true
      );
    };


  const stopDrawing =
    event => {

      if (
        !drawingRef.current
      ) {

        return;
      }


      event.preventDefault();

      drawingRef.current =
        false;


      const canvas =
        canvasRef.current;


      if (!canvas) {
        return;
      }


      try {

        canvas
          .releasePointerCapture(
            event.pointerId
          );

      } catch {
        // ignore
      }
    };


  const clearSignature =
    () => {

      const canvas =
        canvasRef.current;


      if (!canvas) {
        return;
      }


      canvas
        .getContext(
          "2d"
        )
        .clearRect(
          0,
          0,
          canvas.width,
          canvas.height
        );


      setSignatureDrawn(
        false
      );

      setSignError("");
    };


  const submitSignature =
    async () => {

      setSignError("");


      if (!consentAccepted) {

        setSignError(
          "Leia e aceite o termo antes de assinar."
        );

        return;
      }


      if (
        signatureMode ===
          "DRAWN" &&
        !signatureDrawn
      ) {

        setSignError(
          "Desenhe sua assinatura antes de continuar."
        );

        return;
      }


      if (
        signatureMode ===
          "TYPED" &&
        signatureText
          .trim()
          .length < 2
      ) {

        setSignError(
          "Digite sua assinatura antes de continuar."
        );

        return;
      }


      let signatureDataUrl;


      if (
        signatureMode ===
        "DRAWN"
      ) {

        const canvas =
          canvasRef.current;


        if (!canvas) {

          setSignError(
            "Não foi possível acessar a área de assinatura."
          );

          return;
        }


        signatureDataUrl =
          canvas
            .toDataURL(
              "image/png"
            );
      }


      setSigning(
        true
      );


      try {

        const response =
          await api.post(
            "/korax-sign/public/signature",
            {
              token,
              verificationToken,

              consent:
                true,

              signatureType:
                signatureMode,

              signatureText:
                signatureMode ===
                  "TYPED"
                  ? signatureText
                      .trim()
                  : undefined,

              signatureDataUrl:
                signatureMode ===
                  "DRAWN"
                  ? signatureDataUrl
                  : undefined
            }
          );


        if (
          response
            .data
            ?.ok
        ) {

          setSigned(
            true
          );


          const ready =
            Boolean(
              response
                .data
                ?.finalPdfReady
            );


          setFinalReady(
            ready
          );


          if (ready) {

            window
              .sessionStorage
              .setItem(
                `korax_sign_final_${token.slice(0, 16)}`,
                "1"
              );
          }


          window
            .sessionStorage
            .setItem(
              `korax_sign_signed_${token.slice(0, 16)}`,
              "1"
            );
        }

      } catch (err) {

        const status =
          Number(
            err?.response
              ?.status ||
            0
          );


        if (
          status === 401 ||
          status === 403
        ) {

          if (sessionKey) {

            window
              .sessionStorage
              .removeItem(
                sessionKey
              );
          }


          setVerificationToken(
            ""
          );

          setVerified(
            false
          );


          setSignError(
            "Sua sessão segura expirou. Confirme seu e-mail novamente."
          );

        } else {

          setSignError(
            err?.response
              ?.data
              ?.message ||
            "Não foi possível registrar a assinatura."
          );
        }

      } finally {

        setSigning(
          false
        );
      }
    };


  if (loading) {

    return (

      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{
          minHeight:
            "100vh",
          background:
            "#F5F7FA"
        }}
      >
        <CircularProgress
          size={30}
        />
      </Box>
    );
  }


  return (

    <Box
      style={{
        minHeight:
          "100vh",
        background:
          "#F5F7FA",
        padding:
          "34px 16px",
        boxSizing:
          "border-box"
      }}
    >

      <Box
        style={{
          maxWidth:
            620,
          margin:
            "0 auto"
        }}
      >

        <Typography
          style={{
            fontSize:
              20,
            fontWeight:
              950,
            letterSpacing:
              "-0.4px",
            color:
              "#010B36",
            marginBottom:
              18
          }}
        >
          KORAX
        </Typography>


        {error &&
          !session && (

          <Paper
            elevation={0}
            style={{
              border:
                "1px solid #FDA29B",
              borderRadius:
                16,
              padding:
                28,
              background:
                "#FFFFFF"
            }}
          >

            <Typography
              style={{
                fontSize:
                  19,
                fontWeight:
                  900,
                color:
                  "#101828"
              }}
            >
              Não foi possível abrir o documento
            </Typography>

            <Typography
              style={{
                marginTop:
                  10,
                color:
                  "#667085",
                fontSize:
                  13.5,
                lineHeight:
                  1.6
              }}
            >
              {error}
            </Typography>

          </Paper>

        )}


        {session && (

          <Paper
            elevation={0}
            style={{
              border:
                "1px solid #EAECF0",
              borderRadius:
                16,
              padding:
                28,
              background:
                "#FFFFFF"
            }}
          >

            <Typography
              style={{
                color:
                  verified
                    ? "#027A48"
                    : "#175CD3",
                fontSize:
                  12,
                fontWeight:
                  900,
                textTransform:
                  "uppercase",
                letterSpacing:
                  ".4px"
              }}
            >
              {
                verified
                  ? "E-mail confirmado"
                  : "Link seguro confirmado"
              }
            </Typography>


            <Typography
              style={{
                marginTop:
                  9,
                fontSize:
                  22,
                fontWeight:
                  900,
                color:
                  "#101828"
              }}
            >
              {
                session
                  ?.document
                  ?.title ||
                "Documento para assinatura"
              }
            </Typography>


            <Typography
              style={{
                marginTop:
                  7,
                fontSize:
                  13,
                lineHeight:
                  1.55,
                color:
                  "#667085"
              }}
            >
              Olá,{" "}
              <strong>
                {
                  session
                    ?.signer
                    ?.name
                }
              </strong>.
              Você recebeu um documento
              para assinatura eletrônica.
            </Typography>


            <Box
              style={{
                marginTop:
                  22,
                padding:
                  16,
                border:
                  "1px solid #EAECF0",
                borderRadius:
                  11,
                background:
                  "#F9FAFB"
              }}
            >

              <Typography
                style={{
                  fontSize:
                    11,
                  fontWeight:
                    900,
                  color:
                    "#344054"
                }}
              >
                Identificação
              </Typography>


              <Typography
                style={{
                  marginTop:
                    8,
                  fontSize:
                    12.5,
                  color:
                    "#475467"
                }}
              >
                E-mail:{" "}
                {
                  session
                    ?.signer
                    ?.emailMasked ||
                  "-"
                }
              </Typography>


              {session
                ?.signer
                ?.phoneMasked && (

                <Typography
                  style={{
                    marginTop:
                      4,
                    fontSize:
                      12.5,
                    color:
                      "#475467"
                  }}
                >
                  WhatsApp:{" "}
                  {
                    session
                      .signer
                      .phoneMasked
                  }
                </Typography>

              )}


              <Typography
                style={{
                  marginTop:
                    4,
                  fontSize:
                    12.5,
                  color:
                    "#475467"
                }}
              >
                {session?.signer?.identityType === "CNPJ"
                  ? "CNPJ"
                  : "CPF"}:{" "}
                {
                  session?.signer?.identityMasked ||
                  session?.signer?.cpfMasked ||
                  "-"
                }
              </Typography>

            </Box>


            {!verified
              ? (

                <Box
                  style={{
                    marginTop:
                      18,
                    padding:
                      16,
                    border:
                      "1px solid #B2CCFF",
                    borderRadius:
                      11,
                    background:
                      "#F5F8FF"
                  }}
                >

                  <Typography
                    style={{
                      color:
                        "#175CD3",
                      fontSize:
                        13,
                      fontWeight:
                        900
                    }}
                  >
                    Verificação por e-mail
                  </Typography>


                  <Typography
                    style={{
                      marginTop:
                        7,
                      color:
                        "#475467",
                      fontSize:
                        12.5,
                      lineHeight:
                        1.6
                    }}
                  >
                    Enviaremos um código
                    de 6 dígitos para{" "}
                    <strong>
                      {
                        session
                          ?.signer
                          ?.emailMasked
                      }
                    </strong>.
                    O código expira em
                    10 minutos.
                  </Typography>


                  {(codeSent ||
                    cooldown > 0) && (

                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Código de 6 dígitos"
                      value={code}
                      onChange={
                        event =>
                          setCode(
                            onlyDigits(
                              event
                                .target
                                .value
                            )
                          )
                      }
                      inputProps={{
                        maxLength:
                          6,
                        inputMode:
                          "numeric"
                      }}
                      style={{
                        marginTop:
                          16,
                        background:
                          "#FFFFFF"
                      }}
                    />

                  )}


                  {error && (

                    <Typography
                      style={{
                        marginTop:
                          10,
                        color:
                          "#B42318",
                        fontSize:
                          12
                      }}
                    >
                      {error}
                    </Typography>

                  )}


                  {success && (

                    <Typography
                      style={{
                        marginTop:
                          10,
                        color:
                          "#067647",
                        fontSize:
                          12,
                        fontWeight:
                          700
                      }}
                    >
                      {success}
                    </Typography>

                  )}


                  <Box
                    display="flex"
                    style={{
                      gap:
                        10,
                      marginTop:
                        16,
                      flexWrap:
                        "wrap"
                    }}
                  >

                    <Button
                      variant={
                        codeSent
                          ? "outlined"
                          : "contained"
                      }
                      onClick={
                        requestCode
                      }
                      disabled={
                        sending ||
                        cooldown > 0
                      }
                      style={{
                        borderRadius:
                          9,
                        textTransform:
                          "none",
                        fontWeight:
                          850,
                        boxShadow:
                          "none",
                        minWidth:
                          170
                      }}
                    >
                      {
                        sending
                          ? "Enviando..."
                          : cooldown > 0
                            ? `Reenviar em ${cooldown}s`
                            : codeSent
                              ? "Reenviar código"
                              : "Enviar código por e-mail"
                      }
                    </Button>


                    {(codeSent ||
                      code.length > 0) && (

                      <Button
                        variant="contained"
                        onClick={
                          verifyCode
                        }
                        disabled={
                          verifying ||
                          code.length !==
                            6
                        }
                        style={{
                          borderRadius:
                            9,
                          textTransform:
                            "none",
                          fontWeight:
                            850,
                          boxShadow:
                            "none",
                          background:
                            "#0057FF",
                          color:
                            "#FFFFFF",
                          minWidth:
                            145
                        }}
                      >
                        {
                          verifying
                            ? "Verificando..."
                            : "Confirmar código"
                        }
                      </Button>

                    )}

                  </Box>

                </Box>

              )
              : (

                <Box
                  style={{
                    marginTop:
                      18,
                    padding:
                      16,
                    border:
                      "1px solid #ABEFC6",
                    borderRadius:
                      11,
                    background:
                      "#ECFDF3"
                  }}
                >

                  <Typography
                    style={{
                      color:
                        "#067647",
                      fontSize:
                        13,
                      fontWeight:
                        900
                    }}
                  >
                    E-mail verificado
                  </Typography>


                  <Typography
                    style={{
                      marginTop:
                        7,
                      color:
                        "#475467",
                      fontSize:
                        12.5,
                      lineHeight:
                        1.6
                    }}
                  >
                    Seu e-mail foi
                    confirmado para esta
                    sessão segura.
                    O documento foi liberado
                    para visualização.
                  </Typography>

                </Box>
              )
            }


            {verified && (

              <Box
                style={{
                  marginTop:
                    22,
                  border:
                    "1px solid #D0D5DD",
                  borderRadius:
                    12,
                  background:
                    "#F9FAFB",
                  overflow:
                    "hidden"
                }}
              >

                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  style={{
                    padding:
                      "13px 14px",
                    borderBottom:
                      "1px solid #EAECF0",
                    background:
                      "#FFFFFF",
                    gap:
                      12,
                    flexWrap:
                      "wrap"
                  }}
                >

                  <Typography
                    style={{
                      color:
                        "#101828",
                      fontSize:
                        12.5,
                      fontWeight:
                        900
                    }}
                  >
                    Documento
                  </Typography>


                  {pdfPages > 0 && (

                    <Typography
                      style={{
                        color:
                          "#667085",
                        fontSize:
                          11.5
                      }}
                    >
                      Página{" "}
                      {pdfPage}
                      {" "}de{" "}
                      {pdfPages}
                    </Typography>

                  )}

                </Box>


                {pdfLoading && (

                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{
                      minHeight:
                        280,
                      background:
                        "#F2F4F7"
                    }}
                  >

                    <CircularProgress
                      size={28}
                    />

                  </Box>

                )}


                {!pdfLoading &&
                  pdfError && (

                  <Box
                    style={{
                      padding:
                        20,
                      background:
                        "#FFFBFA"
                    }}
                  >

                    <Typography
                      style={{
                        color:
                          "#B42318",
                        fontSize:
                          12.5,
                        lineHeight:
                          1.6
                      }}
                    >
                      {pdfError}
                    </Typography>

                  </Box>

                )}


                {!pdfLoading &&
                  !pdfError &&
                  pdfUrl && (

                  <Box>

                    <Box
                      display="flex"
                      justifyContent="center"
                      style={{
                        padding:
                          "16px 8px",
                        overflowX:
                          "auto",
                        background:
                          "#E4E7EC"
                      }}
                    >

                      <Document
                        file={pdfUrl}
                        onLoadSuccess={({
                          numPages
                        }) => {

                          setPdfPages(
                            Number(
                              numPages ||
                              0
                            )
                          );

                          setPdfPage(
                            current =>
                              Math.min(
                                Math.max(
                                  1,
                                  current
                                ),
                                Number(
                                  numPages ||
                                  1
                                )
                              )
                          );
                        }}
                        onLoadError={() => {

                          setPdfError(
                            "Não foi possível exibir este PDF."
                          );
                        }}
                        loading={(
                          <CircularProgress
                            size={28}
                          />
                        )}
                      >

                        <Page
                          pageNumber={
                            pdfPage
                          }
                          width={
                            pdfWidth
                          }
                          renderTextLayer={
                            false
                          }
                          renderAnnotationLayer={
                            false
                          }
                        />

                      </Document>

                    </Box>


                    {pdfPages > 1 && (

                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{
                          padding:
                            12,
                          background:
                            "#FFFFFF",
                          borderTop:
                            "1px solid #EAECF0",
                          gap:
                            10
                        }}
                      >

                        <Button
                          variant="outlined"
                          disabled={
                            pdfPage <= 1
                          }
                          onClick={() =>
                            setPdfPage(
                              current =>
                                Math.max(
                                  1,
                                  current - 1
                                )
                            )
                          }
                          style={{
                            textTransform:
                              "none",
                            fontWeight:
                              800,
                            borderRadius:
                              8
                          }}
                        >
                          Anterior
                        </Button>


                        <Button
                          variant="outlined"
                          disabled={
                            pdfPage >=
                            pdfPages
                          }
                          onClick={() =>
                            setPdfPage(
                              current =>
                                Math.min(
                                  pdfPages,
                                  current + 1
                                )
                            )
                          }
                          style={{
                            textTransform:
                              "none",
                            fontWeight:
                              800,
                            borderRadius:
                              8
                          }}
                        >
                          Próxima
                        </Button>

                      </Box>

                    )}

                  </Box>

                )}

              </Box>

            )}


            {verified && (

              <Box
                style={{
                  marginTop:
                    22,
                  padding:
                    18,
                  border:
                    signed
                      ? "1px solid #ABEFC6"
                      : "1px solid #D0D5DD",
                  borderRadius:
                    12,
                  background:
                    signed
                      ? "#ECFDF3"
                      : "#FFFFFF"
                }}
              >

                {signed
                  ? (

                    <>

                      <Typography
                        style={{
                          color:
                            "#067647",
                          fontSize:
                            14,
                          fontWeight:
                            900
                        }}
                      >
                        {
                          finalReady
                            ? "Documento assinado e concluído"
                            : finalizing
                              ? "Preparando documento final..."
                              : "Assinatura registrada"
                        }
                      </Typography>


                      <Typography
                        style={{
                          marginTop:
                            7,
                          color:
                            "#475467",
                          fontSize:
                            12.5,
                          lineHeight:
                            1.6
                        }}
                      >
                        {
                          finalReady
                            ? "Sua assinatura foi aplicada ao documento e o processo foi concluído."
                            : finalError
                              ? finalError
                              : "Seu aceite e sua assinatura foram registrados com data, hora e evidências técnicas."
                        }
                      </Typography>


                      {finalReady && (

                        <button
                          type="button"
                          onClick={
                            downloadFinalPdf
                          }
                          style={{
                            marginTop:
                              14,
                            width:
                              "100%",
                            padding:
                              "12px 14px",
                            border:
                              0,
                            borderRadius:
                              9,
                            background:
                              "#0057FF",
                            color:
                              "#FFFFFF",
                            fontSize:
                              13,
                            fontWeight:
                              900,
                            cursor:
                              "pointer"
                          }}
                        >
                          Baixar documento assinado
                        </button>

                      )}

                    </>

                  )
                  : (

                    <>

                      <Typography
                        style={{
                          color:
                            "#101828",
                          fontSize:
                            14,
                          fontWeight:
                            900
                        }}
                      >
                        Assinar documento
                      </Typography>


                      <Typography
                        style={{
                          marginTop:
                            8,
                          color:
                            "#667085",
                          fontSize:
                            12,
                          lineHeight:
                            1.6
                        }}
                      >
                        Leia o documento acima antes de concluir.
                      </Typography>


                      <Box
                        style={{
                          marginTop:
                            14,
                          padding:
                            13,
                          border:
                            "1px solid #EAECF0",
                          borderRadius:
                            9,
                          background:
                            "#F9FAFB"
                        }}
                      >

                        <label
                          style={{
                            display:
                              "flex",
                            alignItems:
                              "flex-start",
                            gap:
                              9,
                            cursor:
                              "pointer"
                          }}
                        >

                          <input
                            type="checkbox"
                            checked={
                              consentAccepted
                            }
                            onChange={
                              event =>
                                setConsentAccepted(
                                  event
                                    .target
                                    .checked
                                )
                            }
                            style={{
                              marginTop:
                                3
                            }}
                          />

                          <span
                            style={{
                              color:
                                "#475467",
                              fontSize:
                                12,
                              lineHeight:
                                1.55
                            }}
                          >
                            Declaro que li e estou de acordo com o
                            conteúdo deste documento e concordo em
                            utilizar assinatura eletrônica nesta
                            operação. Reconheço que o código enviado ao
                            meu e-mail confirmou o acesso a esse endereço
                            eletrônico nesta sessão e que minha ação de
                            assinar será registrada com data, hora,
                            endereço IP e evidências técnicas.
                          </span>

                        </label>

                      </Box>


                      <Box
                        display="flex"
                        style={{
                          marginTop:
                            16,
                          gap:
                            8
                        }}
                      >

                        <button
                          type="button"
                          onClick={() => {

                            setSignatureMode(
                              "DRAWN"
                            );

                            setSignError("");
                          }}
                          style={{
                            flex:
                              1,
                            padding:
                              "10px 12px",
                            borderRadius:
                              8,
                            border:
                              signatureMode ===
                                "DRAWN"
                                ? "1px solid #0057FF"
                                : "1px solid #D0D5DD",
                            background:
                              signatureMode ===
                                "DRAWN"
                                ? "#EFF4FF"
                                : "#FFFFFF",
                            color:
                              signatureMode ===
                                "DRAWN"
                                ? "#004EEB"
                                : "#344054",
                            fontWeight:
                              800,
                            cursor:
                              "pointer"
                          }}
                        >
                          Desenhar
                        </button>


                        <button
                          type="button"
                          onClick={() => {

                            setSignatureMode(
                              "TYPED"
                            );

                            setSignError("");
                          }}
                          style={{
                            flex:
                              1,
                            padding:
                              "10px 12px",
                            borderRadius:
                              8,
                            border:
                              signatureMode ===
                                "TYPED"
                                ? "1px solid #0057FF"
                                : "1px solid #D0D5DD",
                            background:
                              signatureMode ===
                                "TYPED"
                                ? "#EFF4FF"
                                : "#FFFFFF",
                            color:
                              signatureMode ===
                                "TYPED"
                                ? "#004EEB"
                                : "#344054",
                            fontWeight:
                              800,
                            cursor:
                              "pointer"
                          }}
                        >
                          Digitar
                        </button>

                      </Box>


                      {signatureMode ===
                        "DRAWN"
                        ? (

                          <Box
                            style={{
                              marginTop:
                                12
                            }}
                          >

                            <canvas
                              ref={
                                canvasRef
                              }
                              width={
                                900
                              }
                              height={
                                260
                              }
                              onPointerDown={
                                startDrawing
                              }
                              onPointerMove={
                                drawSignature
                              }
                              onPointerUp={
                                stopDrawing
                              }
                              onPointerCancel={
                                stopDrawing
                              }
                              onPointerLeave={
                                stopDrawing
                              }
                              style={{
                                display:
                                  "block",
                                width:
                                  "100%",
                                height:
                                  170,
                                border:
                                  "1px dashed #98A2B3",
                                borderRadius:
                                  9,
                                background:
                                  "#FFFFFF",
                                touchAction:
                                  "none",
                                cursor:
                                  "crosshair",
                                boxSizing:
                                  "border-box"
                              }}
                            />


                            <button
                              type="button"
                              onClick={
                                clearSignature
                              }
                              style={{
                                marginTop:
                                  8,
                                border:
                                  0,
                                background:
                                  "transparent",
                                color:
                                  "#475467",
                                fontSize:
                                  12,
                                fontWeight:
                                  700,
                                cursor:
                                  "pointer"
                              }}
                            >
                              Limpar assinatura
                            </button>

                          </Box>

                        )
                        : (

                          <input
                            type="text"
                            value={
                              signatureText
                            }
                            onChange={
                              event =>
                                setSignatureText(
                                  event
                                    .target
                                    .value
                                    .slice(
                                      0,
                                      160
                                    )
                                )
                            }
                            placeholder="Digite sua assinatura"
                            style={{
                              marginTop:
                                12,
                              width:
                                "100%",
                              boxSizing:
                                "border-box",
                              padding:
                                "17px 14px",
                              border:
                                "1px solid #D0D5DD",
                              borderRadius:
                                9,
                              outline:
                                "none",
                              color:
                                "#101828",
                              fontSize:
                                24,
                              fontFamily:
                                "cursive"
                            }}
                          />

                        )
                      }


                      {signError && (

                        <Typography
                          style={{
                            marginTop:
                              10,
                            color:
                              "#B42318",
                            fontSize:
                              12
                          }}
                        >
                          {signError}
                        </Typography>

                      )}


                      <button
                        type="button"
                        disabled={
                          signing
                        }
                        onClick={
                          submitSignature
                        }
                        style={{
                          marginTop:
                            16,
                          width:
                            "100%",
                          padding:
                            "13px 16px",
                          border:
                            0,
                          borderRadius:
                            9,
                          background:
                            signing
                              ? "#98A2B3"
                              : "#0057FF",
                          color:
                            "#FFFFFF",
                          fontWeight:
                            900,
                          fontSize:
                            13,
                          cursor:
                            signing
                              ? "default"
                              : "pointer"
                        }}
                      >
                        {
                          signing
                            ? "Registrando..."
                            : "Assinar documento"
                        }
                      </button>

                    </>

                  )
                }

              </Box>

            )}


            <Typography
              style={{
                marginTop:
                  18,
                fontSize:
                  11,
                color:
                  "#98A2B3",
                lineHeight:
                  1.55
              }}
            >
              Este link é pessoal.
              Não encaminhe para terceiros.
            </Typography>

          </Paper>

        )}

      </Box>

    </Box>
  );
};


export default
  KoraxSignPublic;
